import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  collections: {},
  requesting: true,

  isDeleted: false,
  deleting: false
};

const Slice = createSlice({
  name: '@admin/Accounts|List',
  initialState,
  reducers: {
    
    getList: (state) => {
        state.collections = {};
        state.requesting = true;
    },
    getListSuccess: (state, action) => {
        const { payload } = action;
        state.collections = payload;
        state.requesting = false;
    },
    getListFailed: (state, action) => {
        state.errors = action.errors;
        state.requesting = false;
    },


  // ----- DELETE ----- 
    toDelete: (state) => {
        state.isDeleted = false;
        state.deleting = true;
    },
    toDeleteSuccess: (state) => {
        state.isDeleted = true;
        state.deleting = false;
    },
    toDeleteFailed: (state, action) => {
        state.errors = action.errors;
        state.deleting  = false;
        state.isDeleted = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminAccountsListReducers: Slice.reducer,
}
export default Reducers;